import BaseStore from 'stores/base'

export default class PendingActionStore extends BaseStore {
  constructor(service, options) {
    super(service)
    this.service = service
  }

  async downloadOverdueInvoiceReport() {
    const { data, error } = await this.service.downloadOverdueInvoiceReport('/invoice/report')
    return { data, error }
  }
}
